<template>
    <UContainer class="my-4 lg:my-8">
        <div class="my-4">
            <UBreadcrumb :links="breadcrumb">
                <template #icon="{ link }">
                    <UtilsDynamicIcon v-if="link.icon" :icon="link.icon" class-name="w-5 h-5 mx-1 -mt-0.5" />
                </template>
            </UBreadcrumb>
        </div>
        <div class="flex max-md:flex-col items-start relative">
            <div class="md:w-1/4 pl-4 sticky top-0 hidden">
                <!-- <div v-if="filtersStatus === 'pending' || true"></div>
                <div v-else class="bg-white rounded-md select-none">
                    <UAccordion
                        color="vista"
                        :items="filtersList"
                        :ui="{
                            wrapper: 'flex flex-col w-full',
                            item: {
                                padding: 'p-0',
                            },
                        }"
                    >
                        <template #default="{ item, index, open }">
                            <UButton
                                color="gray"
                                variant="ghost"
                                :class="{
                                    'border-b border-gray-200 dark:border-gray-700': index < filtersList.length - 1,
                                }"
                                size="md"
                                :ui="{ rounded: 'rounded-none', padding: { md: 'p-6' } }"
                            >
                                <template #leading>
                                    <div
                                        class="w-6 h-6 rounded-full bg-vista-100 dark:bg-vista-900 flex items-center justify-center -my-1"
                                    >
                                        <UIcon
                                            dynamic
                                            v-if="item.icon"
                                            :name="item.icon"
                                            class="w-4 h-4 dark:text-white text-vista-600"
                                        />
                                        <UIcon
                                            v-else
                                            name="i-solar-filters-line-duotone"
                                            class="w-4 h-4 dark:text-white text-vista-600"
                                        />
                                    </div>
                                </template>

                                <span class="truncate mx-2 font-bold">{{ item.name }}</span>

                                <template #trailing>
                                    <UIcon
                                        name="i-solar-alt-arrow-left-outline"
                                        class="w-5 h-5 ms-auto transform transition-transform duration-200"
                                        :class="[open && '-rotate-90']"
                                    />
                                </template>
                            </UButton>
                        </template>
                        <template #item="{ item, index }">
                            <ul
                                class="px-4 py-2 max-h-96 overflow-auto"
                                :class="{
                                    'border-b border-gray-200 dark:border-gray-700': index < filtersList.length - 1,
                                }"
                            >
                                <li v-for="el in item.values" class="p-1">
                                    <UCheckbox :name="`${item.name}-${el}`" :label="el" />
                                </li>
                            </ul>
                        </template>
                    </UAccordion>
                </div> -->
            </div>
            <div class="w-full">
                <div class="bg-white px-4 my-4 rounded-md shadow-37 shadow-sandstone-100 dark:shadow-sandstone-900">
                    <!-- Mobile Sort Dropdown -->
                    <div class="flex md:hidden gap-4 items-center py-2">
                        <UiComponentTypography variant="body2" class-name="font-bold">
                            مرتب‌سازی:
                        </UiComponentTypography>
                        <USelectMenu
                            class="w-1/2"
                            v-model="activeSortItem"
                            :options="sortItems"
                            option-attribute="name"
                            @change="changeProductsSortMobile"
                        >
                            <template #label>
                                <div class="flex gap-2">
                                    <UIcon class="w-5 h-5 block" :name="activeSortItem.icon" />
                                    <UiComponentTypography variant="subtitle">
                                        {{ activeSortItem.name }}
                                    </UiComponentTypography>
                                </div>
                            </template>
                        </USelectMenu>
                    </div>
                    <!-- Desktop Sort List -->
                    <ul class="hidden md:flex items-center gap-6">
                        <li>
                            <UiComponentTypography variant="body2" class-name="font-bold">
                                مرتب‌سازی:
                            </UiComponentTypography>
                        </li>
                        <li
                            v-for="(item, index) in sortItems"
                            class="relative flex items-center gap-2 py-2 text-gray-600 cursor-pointer hover:text-gray-800"
                            :class="activeSortIndex === index ? 'active' : 'hover'"
                            @click="changeProductsSort(index)"
                        >
                            <UIcon class="w-5 h-5 block" :name="item.icon" />
                            <UiComponentTypography
                                variant="subtitle"
                                :class-name="activeSortIndex === index ? 'text-amazon-500 font-bold' : ''"
                            >
                                {{ item.name }}
                            </UiComponentTypography>
                        </li>
                    </ul>
                </div>
                <div class="w-full max-md:mt-6 md:grid md:grid-cols-3 gap-6">
                    <WidgetsProductCard
                        class="max-md:mt-6"
                        :is-loading="productsStatus === 'pending'"
                        :eager="index < 3"
                        v-for="(item, index) in productsList"
                        :key="item?.id || index"
                        :product="item"
                    />
                </div>
            </div>
        </div>
        <PagesCategoryMeta v-if="productsStatus !== 'pending' && products" :category="products.data.category" />
    </UContainer>
</template>

<script lang="ts" setup>
import type { ICategoryProducts } from "~/libs/types/api/category";
import type { IPagination } from "~/libs/types/api/pagination";
import type { BreadcrumbLink } from "#ui/types";

const { t } = useI18n();
const route = useRoute();

const sortItems = [
    {
        name: "پیش‌فرض",
        icon: "i-solar-sort-from-top-to-bottom-bold-duotone",
        value: "-is_in_stock,order",
    },
    {
        name: "جدیدترین",
        icon: "i-solar-sort-by-time-line-duotone",
        value: "-is_in_stock,-created_at,order",
    },
    {
        name: "ارزان‌ترین",
        icon: "i-solar-tag-price-line-duotone",
        value: "-is_in_stock,lowest_price",
    },
    {
        name: "گران‌ترین",
        icon: "i-solar-tag-price-line-duotone",
        value: "-is_in_stock,-lowest_price",
    },
];

const activeSortIndex: Ref<number> = ref(0);
const activeSortItem = ref(sortItems[0]);

const {
    data: products,
    status: productsStatus,
    error: productsError,
    refresh: productsRefresh,
} = await useAsyncData<IPagination<ICategoryProducts>>(`category_products_${route.params.slug.at(-1)}`, () =>
    fetchData(`/category/${route.params.slug.at(-1)}/products`, {
        params: {
            sort: sortItems[activeSortIndex.value].value,
        },
    })
);

// const {
//     data: filters,
//     status: filtersStatus,
//     error: filtersError,
//     refresh: filtersRefresh,
// } = await useGlobalFetch<ICategoryAttributes[]>(`/category/${route.params.slug.at(-1)}/filters`, {});

// const filtersList = computed(() => {
//     return useFilter(filters.value, (item) => item.type === "dropdown" || item.type === "multi-select");
// });

const productsList = computed(() => products.value?.data.products ?? new Array(6).fill(null));

const breadcrumb: ComputedRef<BreadcrumbLink[]> = computed(() => {
    return [
        {
            icon: "i-solar-home-angle-line-duotone",
            label: "",
            to: "/",
        },
        {
            label: t("categories"),
            to: "/category",
            icon: "i-solar-layers-minimalistic-line-duotone",
        },
        ...getCategoryArray(products.value?.data.category).reverse(),
    ];
});

function changeProductsSort(index: number) {
    activeSortIndex.value = index;
    productsRefresh();
}

function changeProductsSortMobile(item: any) {
    const index = useFindIndex(sortItems, item);
    changeProductsSort(index);
}
</script>

<style scoped>
.active {
    @apply text-amazon-500;
}
.active::after {
    content: "";
    @apply absolute w-full h-1 bottom-0 left-0 bg-amazon-500 rounded-t-full;
}

.hover::after {
    content: "";
    /* top: calc(100% - 4px); */
    @apply absolute w-full h-0 bottom-0 left-0 bg-gray-300 rounded-t-full transition-all duration-100;
}
.hover:hover::after {
    content: "";
    @apply h-0.5;
}
</style>
